module.exports = __webpack_public_path__ + "static/media/animal-horse5.6e6892c2.aac";